/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavedViewCreateRequest extends models.SavedViewBase {
    getFixupPrototypeFunction() { return SavedViewCreateRequest.fixupPrototype; }

    static newInstance(model: Partial<SavedViewCreateRequest>): SavedViewCreateRequest {
        let obj = Object.assign(new SavedViewCreateRequest(), model);
        SavedViewCreateRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavedViewCreateRequest>): SavedViewCreateRequest {
        if (!model) return null;
        return SavedViewCreateRequest.newInstance(<SavedViewCreateRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavedViewCreateRequest) {
        if (!obj) return;

        models.SavedViewCreateRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavedViewCreateRequest): boolean {
        if (models.SavedViewBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, SavedViewCreateRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
